module.exports = __webpack_public_path__ + "img/twitter-wrapped.9f4198cb.png";